import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TEditCustomerDetailsReduxParams } from '~types/feat/customer';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchEditCustomerDetails(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerEditCustomerDetailsAttempt', handleEditCustomerDetails, api);
}

function* handleEditCustomerDetails(api: CustomerGateway, data: PayloadAction<TEditCustomerDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const customerId = reduxState.customer.customerDetails.customerId;

    if (!Object.keys(data).length) {
        yield put(combinedActions.customerEditCustomerDetailsFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.editCustomerDetails], {
        authToken,
        customerId,
        ...data.payload,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerEditCustomerDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetCustomerListingAttempt());
        yield put(combinedActions.customerEditCustomerDetailsSuccess());
        yield put(combinedActions.customerSetCustomerDetailsModalIsEditing(false));
        yield put(combinedActions.customerSetCustomerDetailsModalIsOpen(false));

        toast.success(SuccessMessages.CustomerEditCustomerDetailsSuccess);
    }
}
